import { useThemeVariant } from '../../theme/useThemeVariant';
import logoOnLight from './Waadoo.logo.png';
import logoOnDark from './Waadoo.logo.dark.png';

/**
 * The logo file for the active theme. Both files are the Waadoo mark cropped to
 * its bounding square, redrawn from the original 300 px artwork with thicker,
 * fully opaque strokes (144 px, 4x the 36 px the sidebar draws it at): the
 * original's hairline strokes faded to a pale smudge at that size, and merely
 * dilating their anti-aliased alpha left them translucent and streaky. The
 * dark variant draws the mark's black stroke in the dark-mode ink (#e8eaed),
 * since black vanishes on the dark sidebar. How the files are produced:
 * CUSTOMIZATIONS.md, 2026-10-07.
 */
export function useLogoSrc(): string {
  return useThemeVariant(logoOnLight, logoOnDark);
}
